import React from "react"
import Index from "./Index"
import { contentLayout, modules } from "../config/pages"
import { useUser } from "../contexts/UserContext"
import Forbidden from "./Forbidden"

function StockOverrideList() {
  const { user } = useUser()
  let view = contentLayout[modules.StockOverrideList]
  if (user.permissions.views.length && !user.permissions.views.join().includes(modules.StockOverrideList.toLowerCase())) {
    view = Forbidden
  }
  return (
    <Index content={view} module={modules.StockOverrideList}></Index>
  )
}

export default StockOverrideList
